import React, {useEffect, useState} from 'react';
import Slide from './Slide.js';
import styled, {withTheme} from 'styled-components';
import Sid from '../../../assets/img/carousel/SID_selfie.png';
import ButtonBg from '../../../assets/img/carousel/buttonBackground.svg';
import Arrow from '../../../assets/img/carousel/arrow.svg';
import {NAVBAR_HEIGHT, TRANSITION_CLASS_LEFT, TRANSITION_CLASS_RIGHT, TRANSITION_DURATION, ENTRANCE_CLASS_LEFT, ENTRANCE_CLASS_RIGHT,
        MAHABALIPURAM, NAINITAL, MYSORE} from './carousel-constants.js'
import IncredibleIndiaLogo from '../../../assets/img/carousel/incredible-india-logo.png';
import { useHistory, useLocation } from "react-router-dom";

const StyledCarousel = styled.div`
    width: calc(10px + 100vw);
    overflow: hidden;
    position: relative;
    transition: height 400ms ease-in;
    height: ${props => props.header ?  `calc((var(--vh, 1vh) * 100) - ${NAVBAR_HEIGHT + 60}px)` : `calc((var(--vh, 1vh) * 100) - ${NAVBAR_HEIGHT}px)`};
    transform: translate3d(-5px,0,0);
`;

const TransitionCurtain = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: ${props => props.theme.colors.header1};
    z-index: 9999;
    transition: opacity 400ms ease-in;
    opacity: ${props => props.show ? '1' : '0'};
    display: ${props => props.render ? 'flex' : 'none'};
    justify-content: center;
    align-items: center;
`;

const Loading = styled.p`
    color: #FFF;
    font-size: 1rem;
    text-align: center;
    margin: auto;
    margin-top: .5rem;
    font-family: ${props => props.theme.fonts.text};
`;

const IncredibleIndia = styled.img`
    margin: auto;
    height: 2rem;
`;

const CarouselFooter = styled.div`
    height: 10px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5000;
`;

const CtaContainer = styled.div`
    display: flex;
    position: relative;
    width: 33%;
    max-width: 400px;
    height: 350px;
    margin: auto;
    margin-top: -50vh;
    z-index: 2000;
    height: 300px
    align-items: center;
    justify-content: center;

    @media (max-width: ${props => props.theme.pageWidth.s}px) {
        width: 70%;
        margin-top: -40vh;
        height: 40vh;
    }

    @media (min-width: ${props => props.theme.pageWidth.s}px) {
        width: 50%;
        margin-top: -50vh;
        height: 45vh;
    }

    @media (min-width: ${props => props.theme.pageWidth.m}px) {
        width: 37%;
        margin-top: -45vh;
        height: 45vh;
    }

    @media (min-width: ${props => props.theme.pageWidth.l}px) {
        width: 30%;
        margin-top: -40vh;
        height: 40vh;
    }

    @media only screen 
    and (min-device-width: 834px) 
    and (max-device-width: 1200px) 
    and (orientation: portrait)  {
        width: 40%;
  }
`;

const Button = styled.p`
    position: absolute;
    bottom: 0;
    left: 50%;
    right: 0;
    transform: translateX(-50%);
    margin-bottom: 2.5rem;
    z-index: 8000;
    box-sizing: border-box;

    font-size: .85rem;
    font-weight: bold;
    font-family: ${props => props.theme.fonts.display};
    color: #ffef00;
    vertical-align: middle;
    text-transform: uppercase;
    text-align: center;

    cursor: pointer;

    display: flex;
    justify-content: center;

    &::before, 
    &::after {
        content: "";
        display: block;
        border-top: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 1em solid #532b2c;
        transition: border-color 200ms ease-out;
    }

    &::before {
        border-left: 0;
        border-right: 1em solid #532b2c;
    }

    transition: opacity 300ms ease-in, color 200ms ease-out;
    ${props => props.fadeout ? 'opacity: 0;' : ''}
    ${props => props.hide ? 'display: none;' : ''}

    div {
        display: flex;
        align-items: center;
        background-color: #532b2c;
        padding: 0 1em;
        transition: background-color 200ms ease-out;
        line-height: 1;
        
        &::before, 
        &::after {
            content: "";
            display: inline-block;
            width: 5px;
            height: 5px;
            margin: 2px 7px 3px;
            border-radius: 50%;
            background-color: #ffef00;
            transition: background-color 200ms ease-out;
        }
    }

    &:hover {
        color: #800040;
        &::before {
            border-right-color: #fff;
        }
        &::after {
            border-left-color: #fff;
        }
        div {
            background: #fff;
            &::before, 
            &::after {
                background-color: #800040;
            }
        }
    }
`;

const Character = styled.img`
    width: 100%;
    position: absolute;
    top: 0;
    left: 15px;
    right: 0;
    margin: auto;


}

`;

const Slider = styled.div`
    height: 100%;
    position: relative;
`;

const FixedArrow = styled.img`
    position: absolute;
    left: ${props => (props.left ? 0 : '') };
    right: ${props => (props.right ? 0 : '') };
    transform: ${props => (props.left ? 'rotate(180deg)' : '') };
    top: 50%;
    z-index: 9000;
    margin: 0 3.5rem;
    cursor: pointer;
    opacity: 1.0;
    transition: opacity 500ms ease-in;
    ${props => props.fadeout ? 'opacity: 0;' : ''}
    ${props => props.hide ? 'display: none;' : ''}

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        margin: 0 1.5rem;
    }
`;

const Mask = styled.svg`
   z-index: -2000;
   position: fixed; 
`;

const Carousel = (props) => {
    const history = useHistory();
    const { pathname } = useLocation();

    const currentCityPath = pathname.substring(pathname.lastIndexOf('/') + 1);
    const isCurrentCityPathValid = props.slides.includes(currentCityPath);
    const currentCityIndex = (isCurrentCityPathValid) ? props.slides.indexOf(currentCityPath) : 0;

    const [transitionCurtainShow, setTransitionCurtainShow] = useState(!props.footer);
    const [transitionCurtainRender, setTransitionCurtainRender] = useState(!props.footer);

    const [currentSlide, setCurrentSlide] = useState(props.footer ? 0 : currentCityIndex);

    const [onTransition, setOnTransition] = useState(false);
    const [headerMode, setHeaderMode] = useState(false);
    const [activeCity, setActiveCity] = useState(props.slides[currentSlide]);

    useEffect(() => {
        if (isCurrentCityPathValid && !props.footer) {
            props.onExploreClick(activeCity);
            setHeaderMode(true);
        }
    }, [])

    const [slidesData, setSlidesData] = useState({
        [NAINITAL]: {
            name: NAINITAL,
            visible: activeCity === NAINITAL ? 'flex' : 'none',
            zIndex: props.slides.indexOf(NAINITAL) === 0 ? 1000 : 100,
            transitionClass: '',
        },
        [MYSORE]: {
            name: MYSORE,
            visible:  activeCity === MYSORE ? 'flex' : 'none',
            zIndex:  props.slides.indexOf(MYSORE) === 0 ? 1000 : 100,
            transitionClass: '',
        },
        [MAHABALIPURAM]: {
            name: MAHABALIPURAM,
            visible:  activeCity === MAHABALIPURAM ? 'flex' : 'none',
            zIndex: props.slides.indexOf(MAHABALIPURAM) === 0 ? 1000 : 100,
            transitionClass: '',
        }
    })

    if (!props.footer) {
        setTimeout(() => {
            setTransitionCurtainShow(false);
            setTimeout(() => {
                setTransitionCurtainRender(false);
            }, 400)
        }, 1800)
    }

    useEffect(() => {
        if (props.footer) {
            setActiveCity(props.slides[currentSlide]);

            setSlidesData({
                [NAINITAL]: {
                    name: NAINITAL,
                    visible: props.slides[currentSlide] === NAINITAL ? 'flex' : 'none',
                    zIndex: props.slides[currentSlide] === NAINITAL  ? 1000 : 100,
                    transitionClass: '',
                },
                [MYSORE]: {
                    name: MYSORE,
                    visible:  props.slides[currentSlide] === MYSORE ? 'flex' : 'none',
                    zIndex:  props.slides[currentSlide] === MYSORE ? 1000 : 100,
                    transitionClass: '',
                },
                [MAHABALIPURAM]: {
                    name: MAHABALIPURAM,
                    visible:  props.slides[currentSlide] === MAHABALIPURAM ? 'flex' : 'none',
                    zIndex: props.slides[currentSlide] === MAHABALIPURAM ? 1000 : 100,
                    transitionClass: '',
                }
            });
        } 
    }, [props.slides]);

    function goToSlide(direction) {
        const slideNumber = currentSlide + direction;
        let whereTo = (slideNumber) % props.slides.length;
        if (whereTo === -1) {
            whereTo = (props.slides.length - 1);
        }
        setCurrentSlide(whereTo);
        return  props.slides[whereTo];
    }

    function transitionFromToLeft(fromCity, toCity) {
        setSlidesData({
            ...slidesData,
            [fromCity]: {
                ... slidesData[fromCity],
                zIndex: 1000,
                visible: 'flex',
                transitionClass: TRANSITION_CLASS_LEFT
            },
            [toCity]: {
                ... slidesData[toCity],
                zIndex: 100, visible: 'flex', transitionClass: ENTRANCE_CLASS_LEFT
            }
        });

        setOnTransition(true);

        setTimeout(() => {
            setActiveCity(toCity);
            setSlidesData({... slidesData, 
                [fromCity]: {
                    ... slidesData[fromCity],
                    zIndex: 10, transitionClass: '', visible: 'none'
                },
                [toCity]: {
                    name: toCity, zIndex: 1000, visible: 'flex', transitionClass: ''
                }
            });
            setOnTransition(false);
        }, TRANSITION_DURATION * 1000);
    }

    function transitionFromToRight(fromCity, toCity) {
        setSlidesData({
            ...slidesData, 
            [fromCity]: {
                ... slidesData[fromCity],
                zIndex: 1000,
                visible: 'flex',
                transitionClass: TRANSITION_CLASS_RIGHT
            },
            [toCity]: {
                ... slidesData[toCity],
                zIndex: 100, visible: 'flex', transitionClass: ENTRANCE_CLASS_RIGHT
            }
        });

        setOnTransition(true);

        setTimeout(() => {
            setActiveCity(toCity);
            setSlidesData({
                ...slidesData, 
                [fromCity]: {
                    ... slidesData[fromCity],
                    zIndex: 10, transitionClass: '', visible: 'none'
                },
                [toCity]: {
                    ... slidesData[toCity],
                    zIndex: 1000, visible: 'flex', transitionClass: ''
                }
            });
            setOnTransition(false);
        }, TRANSITION_DURATION * 1000);
    }

    function onSlideChangeLeft() {
        if (!onTransition) {
            let leftArrowAnimation = document.getElementById("left-arrow-animation");
            leftArrowAnimation.beginElement();
            const fromCity = props.slides[currentSlide];
            const toCity = goToSlide(-1);
            transitionFromToLeft(fromCity, toCity);
        }
    }

    function onSlideChangeRight() {
        if (!onTransition) {
            let rightArrowAnimation = document.getElementById("right-arrow-animation");
            rightArrowAnimation.beginElement();
            const fromCity = props.slides[currentSlide];
            const toCity = goToSlide(+1);
            transitionFromToRight(fromCity, toCity);
        }
    }

    function onExploreClick() {
        history.push(`${activeCity}`);
        if (!props.footer) {
            props.onExploreClick(activeCity);
            setTimeout(() => {
                setHeaderMode(true);    
            }, 600);
        } else {
            setTransitionCurtainRender(true);
            setTimeout(() => {
                setTransitionCurtainShow(true);
                setTimeout(() => {
                    props.onExploreClick(activeCity);
                    window.scrollTo({top: 0});
                    setTimeout(() => {
                        setTransitionCurtainShow(false);
                        setTimeout(() => {
                            setTransitionCurtainRender(false);    
                        }, 500);
                    }, 1000);
                }, 600);
            }, 50);
        }
    }
    
    /**
     * CURRENTLY THE BEST ANIMATION KEYFRAMES
     * 
     * LEFT
     * step 1   M0,1 L1,1 L1,0 L0,0 Q0,.2,0,1
     * step 2   M0,1 L1,1 L1,0 L.5,0 Q0,.5,.5,1
     * step 3   M0,1 L1,1 L1,0 L1,0 Q1,.5,1,1
     * 
     * 
     * RIGHT
     * step 1   M0,1 L0,0 L1,0  Q1,.5,1,1   L1,1
     * step 2   M0,1 L0,0 L.5,0  Q1,.5,.5,1 L.5,1;
     * step 3   M0,1 L0,0 L0,0  Q0,.5,0,1   L0,1
     */

    return (
        <StyledCarousel header={(props.displayedCity && !props.footer)}>
            <Mask width="0" height="0">
                <defs>
                    <clipPath id="mask" clipPathUnits="objectBoundingBox">
                        <path d="M0,1 L0,0 L1,0 Q1,1,1,1 L1,1">
                            <animate id="left-arrow-animation" begin="indefinite" fill="freeze" attributeName="d" dur={`${TRANSITION_DURATION}s`}
                                    values="M0,1 L1,1 L1,0 L0,0 Q0,.5,0,1;
                                            M0,1 L1,1 L1,0 L.5,0 Q0,.5,.5,1;
                                            M0,1 L1,1 L1,0 L1,0 Q1,.5,1,1"
                                    />
                            <animate id="right-arrow-animation" begin="indefinite"  fill="freeze" attributeName="d" dur={`${TRANSITION_DURATION}s`}
                                    values=" M0,1 L0,0 L1,0  Q1,.5,1,1   L1,1;
                                            M0,1 L0,0 L.5,0  Q1,.5,.5,1 L.5,1;
                                            M0,1 L0,0 L0,0  Q0,.5,0,1   L0,1"
                                    />
                        </path>
                    </clipPath>
                </defs>
            </Mask>

            <FixedArrow fadeout={props.displayedCity && !props.footer} 
                        hide={headerMode} 
                        src={Arrow} 
                        alt="left arrow"
                        left={true} 
                        onClick={onSlideChangeLeft}></FixedArrow>
            <Slider> 
                {props.slides.map((city, i) => (
                    <Slide fadeout={props.displayedCity && !props.footer} 
                            header={headerMode && props.displayedCity === city} 
                            footer={props.footer} 
                            key={i}
                            displayData={slidesData[city]}></Slide>
                ))}
            </Slider>
            <FixedArrow fadeout={props.displayedCity && !props.footer} 
                        hide={headerMode} 
                        src={Arrow} 
                        right={true}
                        alt="right arrow" 
                        onClick={onSlideChangeRight}></FixedArrow>
            <CarouselFooter>
                <CtaContainer>
                    <Character src={Sid} alt="Adventurer and storyteller Siddhartha Joshi taking a selfie"></Character>
                    <Button onClick={onExploreClick} fadeout={props.displayedCity && !props.footer} fixed={!props.footer} hide={headerMode}>
                        <div>Explore</div>
                    </Button>
                </CtaContainer>
            </CarouselFooter>
            <TransitionCurtain show={transitionCurtainShow} render={transitionCurtainRender}>
                <div>
                    <IncredibleIndia hide={props.footer} src={IncredibleIndiaLogo} alt="Incredible India"/>
                    <Loading></Loading>
                </div>
            </TransitionCurtain>
        </StyledCarousel>
    );
};

export default withTheme(Carousel);